const Menu =  [
  {
    title: 'Registros mensuales',
    group: 'admin',
    icon: 'fas fa-calendar-alt',
    name: 'attendance/personal',
  },
  {
    title: 'Registros diarios',
    group: 'admin',
    icon: 'fas fa-calendar-day',
    name: 'attendanceDaily',
  },
  {
    title: 'Instalación',
    group: 'admin',
    icon: 'fas fa-info-circle',
    name: 'attendanceInstallation',
  },
  {
    title: 'Personal',
    group: 'admin',
    icon: 'fas fa-id-card',
    name: 'attendanceInstallationEmployees',
  },
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;
